import React from 'react';

const HowItWorks = ({ language }) => {
  const texts = {
    lt: {
      eyebrow: 'Eiga',
      title: 'Trys žingsniai iki seanso',
      subtitle: 'Gidas veda nuo nuotaikos iki kito žingsnio paslaugoje.',
      steps: [
        {
          number: '01',
          title: 'Pasirinkite nuotaiką',
          text: 'Pradėkite nuo takelio, ne nuo ilgo sąrašo be krypties.',
        },
        {
          number: '02',
          title: 'Perskaitykite pastabą',
          text: 'Trumpas tekstas pasako toną, tempą ir kam vakaras tinka.',
        },
        {
          number: '03',
          title: 'Eikite toliau',
          text: 'Mygtukas nuveda į kitą žingsnį, kur atidaroma paslauga.',
        },
      ],
      cta: 'Tęsti',
    },
    en: {
      eyebrow: 'Path',
      title: 'Three steps toward a screening',
      subtitle: 'The guide moves from a mood to the next step in the service.',
      steps: [
        {
          number: '01',
          title: 'Choose a mood',
          text: 'Start from a lane, not from a long list without a direction.',
        },
        {
          number: '02',
          title: 'Read the note',
          text: 'A short text names the tone, the pace, and who the evening is for.',
        },
        {
          number: '03',
          title: 'Go further',
          text: 'The button leads to the next step, where the service opens.',
        },
      ],
      cta: 'Continue',
    },
  };

  const t = texts[language];

  return (
    <section id="section-3" className="border-b border-white/10 py-20">
      <div className="mx-auto grid max-w-6xl gap-14 px-5 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="text-xs uppercase tracking-[0.28em] text-amber">{t.eyebrow}</p>
          <h2 className="mt-4 font-heading text-4xl text-paper sm:text-5xl">{t.title}</h2>
          <p className="mt-4 text-sand">{t.subtitle}</p>
          <a href="/s" className="mt-8 inline-flex border border-amber px-5 py-3 text-amber">
            {t.cta}
          </a>
        </div>
        <ol className="lg:col-span-8">
          {t.steps.map((step) => (
            <li key={step.number} className="grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-8">
              <span className="font-heading text-3xl text-amber">{step.number}</span>
              <div>
                <h3 className="font-heading text-3xl text-paper">{step.title}</h3>
                <p className="mt-2 max-w-xl text-sand">{step.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorks;
